import {reactive} from "vue";
import {BusinessGroupParamsController} from "@/controllers/business/BusinessGroupParamsController";
import {NotificationService} from "@vues/v-common";
import {FILTER_OPERATOR_ENUM} from "@/models/filterOperatorEnum";

const DAY_MS = 24 * 3600 * 1000;


export class AccountingService {
    static data = reactive({
        selectedPeriod: {
            StartPeriodDate : undefined,
            EndPeriodDate : undefined
        },
        selectedProfessional: undefined,
        isFormCompleted: false,
    });

    static init() {
        if (!AccountingService.data.selectedPeriod.StartPeriodDate || !AccountingService.data.selectedPeriod.EndPeriodDate) {
            return AccountingService.fetchDefaultPeriod();
        }
    }

    /**
     * Bornes d'un filtre sur la période sélectionnée, jours de début et de fin inclus.
     * Les opérateurs GREATER_THAN / MINUS_THAN sont stricts : la borne de début est reculée d'une milliseconde
     * et celle de fin avancée d'un jour, sinon les documents datés du premier ou du dernier jour (à minuit) en seraient exclus.
     */
    static periodBounds(period = AccountingService.data.selectedPeriod) {
        return {
            after: new Date(new Date(period.StartPeriodDate).getTime() - 1),
            before: new Date(new Date(period.EndPeriodDate).getTime() + DAY_MS),
        };
    }

    /** Filtres de table « sur la période » pour un champ date */
    static periodFilters(field, period) {
        const {after, before} = AccountingService.periodBounds(period);
        return [
            {field, operator: FILTER_OPERATOR_ENUM.GREATER_THAN.value, variable: after},
            {field, operator: FILTER_OPERATOR_ENUM.MINUS_THAN.value, variable: before},
        ];
    }

    /** Met à jour les filtres de période d'une table (créés par periodFilters) après un changement de période */
    static updatePeriodFilters(filters, field, period) {
        const {after, before} = AccountingService.periodBounds(period);
        const start = filters.find(filter => filter.field === field && filter.operator === FILTER_OPERATOR_ENUM.GREATER_THAN.value);
        const end = filters.find(filter => filter.field === field && filter.operator === FILTER_OPERATOR_ENUM.MINUS_THAN.value);
        if (start) start.variable = after;
        if (end) end.variable = before;
    }

    static haveBusinessOption() {
        return localStorage && localStorage.options && localStorage.options.includes('business');
    }

    static setPeriod(startPeriodDate, endPeriodDate) {
        AccountingService.data.selectedPeriod = {
            StartPeriodDate: startPeriodDate,
            EndPeriodDate: endPeriodDate
        };
    }

    static setProfessional(professional) {
        AccountingService.data.selectedProfessional = professional;
        AccountingService.data.isProfessionalSelected = !!professional;
    }

    static async fetchDefaultPeriod() {
        if(AccountingService.haveBusinessOption) {
            const resp = await BusinessGroupParamsController.get(localStorage.groupId);

            if (!resp.errors) {
                if (resp.defaultTvaStartPeriodDate && resp.defaultTvaEndPeriodDate) {
                    AccountingService.setPeriod(resp.defaultTvaStartPeriodDate, resp.defaultTvaEndPeriodDate);
                } else {
                    (new NotificationService).addNotification("info", "Période de TVA non renseignée");
                }
            } else {
                (new NotificationService).addNotification("warning", "Impossible de récupérer les dates de période de TVA des paramètres de groupe");
            }
        }
    }

}